/**
 * HubSpot API Configuration
 * Configuration for HubSpot form submission integration
 *
 * Note: No API key required for public form submissions
 */

// HubSpot Configuration
export const HUBSPOT_CONFIG = {
  // Your HubSpot Portal ID
  portalId: '9119239',

  // Your HubSpot Form GUID
  formGuid: '567ed60f-7698-4d37-ba24-44b8af95d508',

  // HubSpot Forms API endpoint (public submission - no authentication required)
  apiEndpoint: 'https://api.hsforms.com/submissions/v3/integration/submit'
};

/**
 * Get the full HubSpot form submission URL
 * @returns {string} Full API URL for form submission
 */
export function getHubSpotFormUrl() {
  const { portalId, formGuid, apiEndpoint } = HUBSPOT_CONFIG;
  return `${apiEndpoint}/${portalId}/${formGuid}`;
}
